export default __webpack_public_path__ + "static/media/heads-02.3933002e.svg";